module.exports = __webpack_public_path__ + "img/logo.7b727581.png";